import { CarouselAutoplaySpeedEnum } from "../types";

const CAROUSEL_AUTOPLAY_SPEED: Record<CarouselAutoplaySpeedEnum, number> = {
  [CarouselAutoplaySpeedEnum.Fast]: 5000,
  [CarouselAutoplaySpeedEnum.Medium]: 10000,
  [CarouselAutoplaySpeedEnum.Slow]: 15000,
};

export const getCarouselAutoplaySpeed = (speed: CarouselAutoplaySpeedEnum) => {
  return (
    CAROUSEL_AUTOPLAY_SPEED[speed] ??
    CAROUSEL_AUTOPLAY_SPEED[CarouselAutoplaySpeedEnum.Medium]
  );
};
